/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useState, useRef, useEffect } from "react";
import PropTypes from "prop-types";
import { IoMdClose } from "@react-icons/all-files/io/IoMdClose";
import Link from "gatsby-core-theme/src/hooks/link";
import LazyImage from "gatsby-core-theme/src/hooks/lazy-image";
import useTranslate from "~hooks/useTranslate/useTranslate";
import styles from "./market-dropdown.module.scss";

const MarketDropdown = ({
  pageContext,
  defaultMarket = "Ontario",
  showMarket = false,
  marketValues = {
    se: "Sverige",
    dk: "Danmark",
  },
  customCss = null,
}) => {
  const { allMarkets, page } = pageContext;
  const containerRef = useRef(null);
  const dropdownRef = useRef(null);
  const [isActive, setIsActive] = useState(false);
  const selectMarketText = useTranslate("select_market", "Select Market");
  const defaultMarketText = useTranslate("defaultMarket", defaultMarket);
  const activeMarket = allMarkets[page.market] || "gb_en";
  const marketOptions = Object.keys(allMarkets).map((key) => [
    key,
    allMarkets[key],
  ]);

  const onClick = () => {
    setIsActive(!isActive);
  };

  activeMarket.market = page.market;

  useEffect(() => {
    function handleClickOutside(event) {
      if (
        containerRef.current &&
        !containerRef.current.contains(event.target)
      ) {
        setIsActive(false);
      }
    }

    // Bind the event listener
    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [containerRef]);

  return (
    marketOptions.length > 1 && (
      <div
        className={`${styles.dropdownContainer} ${
          isActive && styles.RemoveBorder
        } ${customCss ? customCss || '' : ''}`}
        ref={containerRef}
      >
        <div
          className={`${styles.dropdown}`}
          onKeyDown={() => onClick()}
          onClick={() => onClick()}
        >
          <div
            className={`${isActive && styles.dropdownActive} ${
              styles.dropdownInner
            }`}
          >
            <LazyImage
              width={18}
              height={18}
              src={`/images/markets/${
                !activeMarket.path_prefix
                  ? "marketdefault"
                  : activeMarket.market
              }.svg`}
              loading="eager"
              alt={activeMarket.market}
            />
            {showMarket && (
              <span className={styles.marketTitle}>
                {(activeMarket.path_prefix !== null && activeMarket.path_prefix !== undefined)
                  ? activeMarket.path_prefix
                  : defaultMarketText}
              </span>
            )}
          </div>
        </div>
        <div
          ref={dropdownRef}
          className={`${styles.dropdownOptions}  ${
            isActive && styles.RemoveBorderOptions
          } ${isActive ? styles.active : ""}`}
        >
          <span className={styles.marketText}>
            {selectMarketText}
            <IoMdClose onClick={() => onClick()} />
          </span>

          <div className={styles.triangle} />
          {marketOptions.map((item) => {
            if (item[0] !== activeMarket.market) {
              const langPage = page.hreflangs
                ? page.hreflangs.filter((lang) => {
                    const nonActiveMarket = item[0].split("_");
                    return (
                      lang.language === nonActiveMarket[1] &&
                      lang.country === nonActiveMarket[0]
                    );
                  })
                : [];

              const prefix = item[1].path_prefix;
              /* eslint-disable react-hooks/rules-of-hooks */
              const marketText =
                prefix &&
                useTranslate(prefix, marketValues[prefix] || prefix);
              const path =
                langPage.length > 0 ? langPage[0].path : prefix || "/";

              return (
                <Link
                  aria-label={item[0]}
                  to={path}
                  className={styles.marketLink}
                >
                  <LazyImage
                    width={24}
                    height={24}
                    src={`/images/markets/${
                      !prefix ? "marketdefault" : item[0]
                    }.svg`}
                    loading="eager"
                    alt={prefix}
                  />
                  <span>
                    {prefix ? marketText : defaultMarketText}
                  </span>
                </Link>
              );
            }
            return <></>;
          })}
        </div>
      </div>
    )
  );
};

MarketDropdown.propTypes = {
  pageContext: PropTypes.shape({
    allMarkets: PropTypes.shape({}),
    page: PropTypes.shape({
      market: PropTypes.string,
      hreflangs: PropTypes.arrayOf(PropTypes.shape({})),
    }),
  }),
  section: PropTypes.shape({}),
  defaultMarket: PropTypes.string,
  showMarket: PropTypes.bool,
  marketValues: PropTypes.shape({}),
  customCss: PropTypes.string,
};

export default MarketDropdown;
